import { useToast } from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-bootstrap.css'

const toast = useToast({ position: 'top', duration: 3000 })
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('toast', toast)

  // @ts-expect-error 'assert userStore exists'
  const checked = nuxtApp.$userStore.user_checked
  // @ts-expect-error 'assert userStore exists'
  const check_error = nuxtApp.$userStore.user_check_error

  if (checked && check_error) {
    if (check_error === 401) {
      // toast.warning("Please Log-In to Continue", {position: "bottom"})
    } else if (check_error === 504) {
      toast.error(
        'Could not reach server (Bad Gateway). Please refresh the page or try again later',
        { duration: 10000 },
      )
    } else {
      toast.error('Could not reach server', { duration: 10000 })
    }
  }
})
